export default "__VITE_ASSET__c1c7266b__"